import {jwtDecode} from 'jwt-decode';
import sha256 from 'crypto-js/sha256';

const clientId = "bpi_website";
const configurationUrl = 'https://login.trisotech.com/realms/BPI/.well-known/openid-configuration';
const accountUrl = 'https://login.trisotech.com/realms/BPI/account';

const getOAuthConfig = async () => {
    var response = await fetch(configurationUrl);
    let config = await response.json();
    return config;
};

let bpi_user = null;

class User {
    constructor(obj) {
        this.email = obj.email;
        this.exp = new Date(obj.exp * 1000);
        this.given_name = obj.given_name;
        this.family_name = obj.family_name;
    }

    getName() {
        return `${this.given_name} ${this.family_name}`;
    }

    getEmail() {
        return this.email;
    }

    getPicture() {
        const hash = sha256(this.email);
        return `https://gravatar.com/avatar/${hash}?s=20&d=mm&r=g`;
    }

    setToken(token) {
        this.token = token;
    }

    static load(id_token) {
        let data = jwtDecode(id_token);
        if (new Date(data['exp'] * 1000) > Date.now()) {
            let user = new User(data);
            user.setToken(id_token);
            return user;
        }
    }
}

async function generateCodeChallenge(codeVerifier) {
    var digest = await crypto.subtle.digest("SHA-256",
        new TextEncoder().encode(codeVerifier));

    return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

function generateRandomString(length) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

const login = async () => {
    let config = await getOAuthConfig();

    let codeVerifier = generateRandomString(64);
    window.sessionStorage.setItem("code_verifier", codeVerifier);
    let codeChallenge = await generateCodeChallenge(codeVerifier);
    var redirectUri = window.location.href.split('?')[0];
    var args = new URLSearchParams({
        response_type: "code",
        client_id: clientId,
        code_challenge_method: 'S256',
        code_challenge: codeChallenge,
        redirect_uri: redirectUri,
        scope: "openid"
    });
    window.location = config['authorization_endpoint'] + "/?" + args;
};

const getIdToken = async (code) => {
    let config = await getOAuthConfig();

    var response = await fetch(config['token_endpoint'], {
        method: 'POST',
        mode: 'cors',
        headers: {'Content-type': 'application/x-www-form-urlencoded'},
        credentials: 'omit',
        body: new URLSearchParams({
            client_id: clientId,
            code_verifier: window.sessionStorage.getItem("code_verifier"),
            grant_type: "authorization_code",
            redirect_uri: location.href.replace(location.search, ''),
            code: code,
            scope: "openid"
        })
    });

    let data = await response.json();
    if (data['id_token']) {
        return data['id_token'];
    }
};

/*
 * Overlay
 */
const setLoginOverlay = () => {
    //If the user is not logged it, we change all actionable items (thumbnails) to point to the login/register page
    if (!bpi_user) {
        var $overlays = $('.actionable-overlay');
        $overlays.find('.actionable-overlay-icon').empty().append('<i class="fa-solid fa-right-to-bracket"></i>');
        $overlays.find('.actionable-overlay-text').empty().html('Login or Sign Up');
        $overlays.unbind().click(function (event) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            event.preventDefault();
            login();
        });
        $('div.action-button a.require-login').unbind().attr('title', 'Login or Sign Up').click(function (event) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            event.preventDefault();
            login();
        });
        $('.feed-action').attr('href', $('#login-profile-button').attr('href')).attr('title', 'Login or Sign up');
    } else {
        $('#login-profile-button').html('<img  src="' + bpi_user.getPicture() + '"/> ' + bpi_user.getName());
        $('#loginDropdown .myaccount').attr('data-href', accountUrl);

        // ensure control in embeded content are accessible (vimeo, ...)
        $('.actionable-overlay').click(function (event) {
            $(this).hide();
        });
        /*
         * Autocomplete forms
         */
        let nameEl = document.getElementById('txtName');
        let emailEl = document.getElementById('txtEmail');
        if (nameEl) {
            nameEl.value = bpi_user.getName();
        }
        if (emailEl) {
            emailEl.value = bpi_user.getEmail();
        }
    }
};

/*
 * Main flow
 */
(async () => {
    // Restore the openid id token from the session storage
    let token = window.sessionStorage.getItem('bpi_user');

    // Receive code from the IdP
    var args = new URLSearchParams(window.location.search);
    var code = args.get("code");
    if (code) {
        try {
            token = await getIdToken(code);
        } catch (e) {
            token = null;
        }

        /*
         * URL cleanup
         */
        const url = new URL(window.location);
        args.delete('code');
        args.delete('session_state');
        args.delete('iss');
        url.search = args.toString();
        window.history.replaceState({}, null, url.href);
    }

    if (token) {
        bpi_user = User.load(token);
        if (bpi_user) {
            window.sessionStorage.setItem('bpi_user', token);
        }
    }

    setLoginOverlay();
})();


/*
 * Login button
 */
let loginBtn = document.getElementById("login-profile-button");
if (loginBtn) {
    loginBtn.onclick = function(e) {
        e.preventDefault();

        if (bpi_user) {
            var $this = $(this);
            // show context menu
            var pos = $this.parent().position();

            $ul.css({
                top: pos.top + $this.outerHeight() + 34,
                left: pos.left
            });

            $ul.show();
            $ul.focus();
        } else {
            login();
        }
    };
}
/*
 * Dropdown
 */
//Code to handle the login dropdown menu
var $ul = $('#loginDropdown');

$ul.on('click', 'li.loginItem', function (e) {
    var url = $(this).attr('data-href');
    if (url) {
        window.location.href = url;
        $ul.blur();
    }
});

$ul.on('blur', function (e) {
    $(this).hide();
});

//Handle logout
$ul.on('click', 'li.logout', function () {
    (async() => {
        let config = await getOAuthConfig();
        window.sessionStorage.clear();
        var redirectUri = window.location.href.split('?')[0];
        let params = new URLSearchParams({
            id_token_hint: bpi_user.token,
            post_logout_redirect_uri: redirectUri
        });
        window.location.href = config['end_session_endpoint'] + '?' + params;
    })();
});
